import React from "react";
import { observer, inject } from "mobx-react";
import QuestionContainer from "./question";
import LanguageSwitcher from "./_common/language-switcher";
import * as Icon from "react-feather";
import GroupSelector from "./_common/group-selector";

const SurveyEdit = ({ store }) => {
  const { $survey, $locale, $config, $group } = store;
  return (
    $survey.selected && (
      <React.Fragment>
        {!!$survey.selected.editableShowWarning && (
          <div
            className="warning bg-orange color-white hide-for-print"
            style={{ marginTop: "-2rem" }}
          >
            <i>
              Deze enquête heeft reeds inzendingen. Pas op bij het bewerken, toevoegen of
              verwijderen van vragen!
            </i>
          </div>
        )}

        <div className="title ">
          <div className="flex justify-between">
            <div className="flex items-center">
              {store.$survey.selected.questions_for_group && <GroupSelector />}
            </div>
            <div className="flex items-center">
              {store.$survey.selected.languages.split(",").length > 1 && (
                <LanguageSwitcher languages={store.$survey.selected.languages.split(",")} />
              )}

              {store.$config.id === "barometer-disco" && (
                <Icon.Printer
                  className="pointer ml-4"
                  onClick={() => {
                    store.$locale.activeLocaleDirection === "rtl"
                      ? window.print()
                      : window.open(
                          `/survey/edit/${store.$survey.selected._key}/print${
                            store.$group.selected ? "?group=" + store.$group.selected._key : ""
                          }`,
                          "_blank"
                        );
                  }}
                />
              )}

              {store.$config.id === "obs-barometer" && (
                <Icon.Printer
                  className="pointer ml-4"
                  onClick={() => {
                    if (store.$locale.activeLocaleDirection === "rtl") {
                      if (store.$survey.selected._key === "duPk9ttEIdVC2JfxLW0u") {
                        window.open(
                          process.env.PUBLIC_URL +
                            "/barometer-vragenlijst-ouders-basisonderwijs-" +
                            store.$locale.activeLocale +
                            ".pdf",
                          "_blank"
                        );
                      } else {
                        window.print();
                      }
                    } else {
                      window.open(
                        `/survey/edit/${store.$survey.selected._key}/print${
                          store.$group.selected ? "?group=" + store.$group.selected._key : ""
                        }`,
                        "_blank"
                      );
                    }
                  }}
                />
              )}
            </div>
          </div>

          <div className="mt-8 question-container-list">{<QuestionContainer />}</div>
        </div>
      </React.Fragment>
    )
  );
};
export default inject("store")(observer(SurveyEdit));
